import React from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Button, Dialog, Icon, ButtonGroup, Tooltip
} from "@blueprintjs/core";
import constants from '../ndbk-constants'
import MainNav from '../components/MainNav.js'
import ModalVideo from 'react-modal-video';
import SignUpForm from '../components/SignUpForm'
import { Follow } from 'react-twitter-widgets'

const Feature = ({ title, icon, text }) => (
    <div>
        <h4><Icon iconSize="16" icon={icon} style={{ color: "#92138A" }} />{title}</h4>
        <p>{text}</p>
    </div>
)

const exampleNodebooks = [
    '/nodebook/726/t/x=-2440.65&y=283.72&k=0.88',
    '/nodebook/512/t/x=2693.10&y=4086.75&k=0.30',
    '/nodebook/192/t/x=1287.71&y=-321.43&k=0.45',
    '/nodebook/192/t/x=27.27&y=-40.25&k=0.60',
    '/nodebook/701/',
    '/nodebook/725/t/x=-687.65&y=733.14&k=0.68',
]

class LandingPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isVideoModalOpen: false,
            isSignupFormOpen: false,
            exampleIdx: Math.floor(Math.random() * exampleNodebooks.length),
        }
    }

    previousExample = () => {
        this.setState({
            exampleIdx: (this.state.exampleIdx - 1 + exampleNodebooks.length) % exampleNodebooks.length
        })
    }

    nextExample = () => {
        this.setState({
            exampleIdx: (this.state.exampleIdx + 1 + exampleNodebooks.length) % exampleNodebooks.length
        })
    }

    setVideoOpen = (isOpen) => {
        this.setState({ isVideoModalOpen: isOpen })
    }

    setSignupFormOpen = (isOpen) => {
        this.setState({ isSignupFormOpen: isOpen })
    }

    componentDidMount() {
        document.title = constants.WEBSITE_TITLE
    }

    render() {
        if (constants.RENDER_LOGS === true) console.log("LandingPage render.", this.props)

        console.log(this.props)

        return (
            <div className="landing">

                <ModalVideo
                    channel='youtube'
                    isOpen={this.state.isVideoModalOpen}
                    videoId='K3dwNEjTPR8'
                    onClose={() => { this.setVideoOpen(false) }}
                />

                <Dialog
                    isOpen={this.state.isSignupFormOpen}
                    onClose={() => { this.setSignupFormOpen(false) }}
                    title="Create account"
                    icon="new-person"
                // canOutsideClickClose={false}
                >
                    <SignUpForm {...this.props} />
                </Dialog>

                <main>

                    <MainNav {...this.props} />

                    <div className="pitch">
                        <h1>Your digital whiteboards</h1>

                        <h2>Create beautiful graphs with all your papers, files, notes and links,<br />and always have an easy overview of your own thoughts and ideas.</h2>

                        {
                            (this.props.auth.success === false || (this.props.auth.success && this.props.auth.user.isGuest === true)) && (
                                <Button text="Sign Up" intent="success" large onClick={() => { this.setSignupFormOpen(true) }} />
                            )
                        }
                    </div>

                    <div className="demo">
                        <div>

                            <iframe
                                title="Example Nodebook"
                                src={`${exampleNodebooks[this.state.exampleIdx]}?embed&noBackground`}
                                width="100%"
                                height="500"
                                frameBorder="0"
                                allowtransparency="true"
                            ></iframe>
                        </div>
                        <div className="desc">
                            <div>
                                <ButtonGroup minimal><Button title="Previous example" icon="caret-left" onClick={this.previousExample} small /><Button title="Next example" icon="caret-right" onClick={this.nextExample} small /></ButtonGroup>
                            </div>
                            <div>
                                <div><strong>This is a live demo. Play with it right here!</strong> </div>
                                <p>Try to <Tooltip content="Use mouse wheel" position="bottom">
                                    <i>zoom in and out</i>
                                </Tooltip>, <Tooltip content="Click on empty space, hold, and drag" position="bottom">
                                        <i>move around</i>
                                    </Tooltip>, or <Tooltip content="Click on node, hold, and drag" position="bottom">
                                        <i>drag</i>
                                    </Tooltip> and <Tooltip content="Drag node's bottom-right corner" position="bottom">
                                        <i>resize</i>
                                    </Tooltip> nodes.</p>
                            </div>
                        </div>
                    </div>

                    <h3>Features</h3>

                    <div className="features">

                        <Feature
                            icon="lock"
                            title="Public and private collections"
                            text="Control visibility and control who can access it. Share your collections with guests (no need for them to sign up)."
                        />
                        <Feature
                            icon="geosearch"
                            title="Discover community"
                            text="Find out what people are working on and what's popular."
                        />
                        <Feature
                            icon="automatic-updates"
                            title="Live collaboration"
                            text="All changes are automatically synced up with our servers and updated live on other people's screens."
                        />
                        <Feature
                            icon="user"
                            title="Manage your profile"
                            text="Work privately or publicly. Sign in with your social media. Contribute to the whole community and build reputation."
                        />
                        <Feature
                            icon="application"
                            title="Customization"
                            text="Support for LaTeX and inline HTML. Tweak colors and fonts, adjust size and alignment, add icons. Full control over the layout of your collections."
                        />
                        <Feature
                            icon="cloud-upload"
                            title="Files"
                            text="Upload any and all files. Unlimited storage."
                        />
                        <Feature
                            icon="search-template"
                            title="Meta-data"
                            text="Parse PDF files for meta-data with our built-in AI tool. Import and export BibTex. Search the web for additional meta-data."
                        />
                        <Feature
                            icon="filter-list"
                            title="Filter"
                            text="Combine multiple filters such as by tags and authors to easily filter out the content that interests you."
                        />
                        <Feature
                            icon="flow-branch"
                            title="Advanced search"
                            text="Specify the tiniest details of what it is that you're looking for with our completely new visual search tool."
                        />
                        <Feature
                            icon="clipboard"
                            title="Smart copy-paste"
                            text="Automatically extract pasted URLs, node data, BibTex and other things."
                        />
                        <Feature
                            icon="time"
                            title="Quick access"
                            text="Switch quickly between your most recently used collections."
                        />
                        <Feature
                            icon="git-new-branch"
                            title="Contributing"
                            text="Suggest new content and changes to other people's collections. Review and discuss proposals and determine their approval."
                        />
                        <Feature
                            icon="git-branch"
                            title="Forking"
                            text="Create branches of other people's collections. Continue your work privately or publicly. Keep track of updates to the master branch."
                        />
                        <Feature
                            icon="git-pull"
                            title={`Compare & merge`}
                            text="Easily figure out what other collections have that yours don't, and then use that. Merge parts of multiple collections."
                        />
                        <Feature
                            icon=""
                            title=""
                            text=""
                        />
                    </div>

                    <div className="social">
                        <Follow username="nodebook_io" options={{ showCount: false, size: "large" }} />
                        {/* <a href="https://draganokan.typeform.com/to/YPse8BK8">Contact Us</a> */}
                    </div>
                </main>
            </div>
        );
    }

}

export default withRouter(LandingPage);


// WEBPACK FOOTER //
// ./src/pages/LandingPage.js